import { useTranslation } from 'react-i18next'

import { useFetchLoyaltyLevelInfo } from '@entities/Loyalty'

import { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import styles from '@features/main-page-builder/ui/styles.module.scss'

export default function LoyaltyLevelBlock (_props: BlockProps) {
  const { t } = useTranslation()
  const { loyaltyStatusInfo, loading } = useFetchLoyaltyLevelInfo()

  // Логика как в customer-app: не показываем блок если нет nextLevel
  if (loading || !loyaltyStatusInfo?.nextLevel) {
    return null
  }

  return (
    <div className={styles.root__loyaltyLevel}>
      <div className={styles.loyaltyLevel__content}>
        <h3>{t('loyalty.level.current')}: {loyaltyStatusInfo.currentLevel?.name}</h3>
        <div className={styles.loyaltyLevel__info}>
          <p>{loyaltyStatusInfo.currentLevel?.preference}{loyaltyStatusInfo.currentLevel?.preferencePostfix} {t('loyalty.level.cashback')}</p>
          {loyaltyStatusInfo.nextLevel && (
            <>
              <p>{t('loyalty.level.next')}: {loyaltyStatusInfo.nextLevel.name}</p>
              <p>{t('loyalty.level.needToNext')}: {loyaltyStatusInfo.nextLevel.needToNextLevel} {t('loyalty.level.points')}</p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}